import { styled } from "@glitz/react";
import { spacing, fontSize, black, red, green } from "../../theme";
import { GrAlert } from "react-icons/gr";

const InputWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: spacing.xxs,
  width: "100%",
});

const Label = styled.label({
  fontSize: fontSize.s,
  color: "#333",
  fontWeight: 600,
});

const HelpText = styled.div({
  fontSize: fontSize.s,
  color: red,
  fontWeight: 500,
  display: "flex",
  gap: spacing.xxs,
  alignItems: "center",
});

const InputField = styled.input({
  padding: { xy: spacing.s },
  fontSize: fontSize.s,
  border: { xy: { style: "solid", color: black, width: "1px" } },
  borderRadius: "4px",
  transitionProperty: "border-color",
  transitionDuration: "0.2s",
  transitionTimingFunction: "ease",
  ":focus": {
    outline: { style: "none" },
    border: { xy: { style: "solid", color: green, width: "1px" } },
  },
});

const ErrorDecor = styled({
  border: { xy: { style: "solid", color: red, width: "1px" } },
});

const WarningIcon = styled(GrAlert, {});

type InputProps = {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  type?: string;
  placeholder?: string;
  error?: boolean;
  helpText?: string;
};

const Input: React.FC<InputProps> = ({
  label,
  value,
  onChange,
  onKeyDown,
  type = "text",
  placeholder,
  error,
  helpText,
}) => {
  return (
    <InputWrapper>
      <Label>{label}</Label>
      <InputField
        type={type}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        css={error && ErrorDecor}
      />
      {helpText && (
        <HelpText>
          <WarningIcon />
          {helpText}
        </HelpText>
      )}
    </InputWrapper>
  );
};

export default Input;
